export enum EExportDashletType {
  SIMPLE = 'SIMPLE',
  ADVANCED = 'ADVANCED',
}
